// Auto-generated file created by svgr-cli source svg-template.js
// Run pnpm run create to update
// Do not edit
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDataDonutChartSolid = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    aria-hidden="true"
    {...props}
  >
    <path
      fill="currentColor"
      d="M11 5.66c0 .244-.177.45-.415.508a6.002 6.002 0 0 0-4.34 7.536.53.53 0 0 1-.232.613l-2.649 1.53a.48.48 0 0 1-.691-.233A9.976 9.976 0 0 1 2 12c0-4.996 3.664-9.137 8.452-9.88A.48.48 0 0 1 11 2.6zM17.99 14.304a.53.53 0 0 1-.232-.612 6.002 6.002 0 0 0-4.343-7.524A.531.531 0 0 1 13 5.66V2.6a.48.48 0 0 1 .548-.482C18.336 2.863 22 7.004 22 12c0 1.27-.236 2.483-.668 3.6a.48.48 0 0 1-.691.234zM19.639 17.565a.48.48 0 0 1 .143.716A9.98 9.98 0 0 1 12 22a9.98 9.98 0 0 1-7.773-3.708.48.48 0 0 1 .143-.717l2.65-1.53a.53.53 0 0 1 .646.104A5.983 5.983 0 0 0 12 18c1.71 0 3.25-.714 4.344-1.86a.53.53 0 0 1 .646-.105z"
    />
  </svg>
);
export default SvgDataDonutChartSolid;
